import React__default from 'react';
import { Skeleton } from '../../../skeleton/skeleton.js';

var sizes = {
  xs: {
    height: '16px',
    heightWithSub: '16px',
    width: '100%'
  },
  s: {
    height: '20px',
    heightWithSub: '20px',
    width: '100%'
  },
  m: {
    height: '24px',
    heightWithSub: '20px',
    width: '100%'
  },
  l: {
    height: '24px',
    heightWithSub: '20px',
    width: '100%'
  }
};
var ValueLoader = function ValueLoader(_ref) {
  var size = _ref.size,
      secondaryState = _ref.secondaryState;
  var _sizes$size = sizes[size],
      height = _sizes$size.height,
      width = _sizes$size.width,
      heightWithSub = _sizes$size.heightWithSub;
  var heightValue = secondaryState === 'with-secondary' ? heightWithSub : height;
  return /*#__PURE__*/React__default.createElement(Skeleton, {
    rounding: 8,
    height: heightValue,
    width: width
  });
};

export { ValueLoader };
